import ResumeActions from './ResumeActions';
export default ResumeActions;